module.exports = __webpack_public_path__ + "static/img/King of Swords.d30c2b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/King of Swords.jpg
// module id = 1277
// module chunks = 0